export const MAIN_PROPS = [
    "country",
    "duration",
    "seedKeyword",
    "webSource",
    "booleanSearchTerms",
    "volumeFromValue",
    "volumeToValue",
    "cpcFromValue",
    "cpcToValue",
    "difficultyFromValue",
    "difficultyToValue",
];

export const TABLE_SELECTION_KEY = "KeywordGeneratorToolTable";
export const TABLE_SELECTION_PROPERTY = "keyword";
export const GOOGLE_KEYWORD_GENERATOR_ENDPOINT = `/api/KeywordGenerator/google/suggest`;
export const GOOGLE_KEYWORD_GENERATOR_EXCEL_ENDPOINT = `/api/KeywordGenerator/google/suggest/excel`;
export const TABLE_TYPES_FOR_ENDPOINT = {
    related: "Related",
    broad: "Broad",
};
export const LABELS_FOR_TABLE_TYPES = {
    trending: "Trending",
    questions: "Questions",
};
